import React, { useEffect, useState } from "react";
import "../styles/template.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { createSearchParams, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import secondaryImage from "../assets/images/swageazy-mascot-new-Logo.png";
import axios from "axios";
import {
  getTemplateData,
  getCouponItems as fetchCouponItems,
  ALL_PACKS_OUT_OF_STOCK_MESSAGE,
  isPackInStock,
  isRateLimited,
  RATE_LIMIT_MESSAGE,
} from "../services/apiservice";
import { toast } from "react-toastify";
import LayoutComponent from "./LayoutComponent";
import GradientHeader from "./GradientHeader";

export const Redemption = () => {
  const [loading, setLoading] = useState(true);
  const [selectedPack, setSelectedPack] = useState(null);
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState({
    backgroundColor: "",
    logoImageUrl: "",
    secondaryImageUrl: "",
    heading: "",
    content: "",
    buttonColor: "",
    layout: 2,
    buttonText: "",
    textColor: "",
    ctaColor: "",
    headerColor: "",
    customerId: null,
  });
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get("token");
  const params = { token };

  useEffect(() => {
    if (selectedPack) {
      navigate(`/redemption/details?token=${token}`, {
        state: { selectedPack },
      });
    }
  }, [selectedPack]);

  useEffect(() => {
    if (token === null || token === "" || token === undefined) {
      navigate("/");
      setTemplateData({
        logoImageUrl: "",
        secondaryImageUrl: secondaryImage,
      });
      setLoading(false);
      return;
    }
    getTemplateIdFromCoupon();
  }, []);

  function getTemplateIdFromCoupon() {
    getTemplateData()
      .then((response) => {
        setTemplateData({
          backgroundColor:
            response.data.result.page_background_color ||
            response.data.result.pageBackgroundColor,
          logoImageUrl:
            response.data.result.logo_image_url ||
            response.data.result.logoImageUrl,
          secondaryImageUrl:
            response.data.result.secondary_image_url ||
            response.data.result.secondaryImage,
          heading: response.data.result.heading,
          content: response.data.result.content,
          buttonColor:
            response.data.result.button_color ||
            response.data.result.buttonColor,
          layout: response.data.result.layout || 2,
          buttonText: response.data.result.button_text || "Redeem Your Gift",
          textColor:
            response.data.result.text_color || response.data.result.textColor,
          ctaColor:
            response.data.result.cta_color || response.data.result.ctaColor,
          headerColor: response.data.result.header_color || "",
          customerId: response.data.result.customer_id ?? null,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setTemplateData({
          logoImageUrl: "",
          secondaryImageUrl: secondaryImage,
        });
      });
  }

  async function checkCouponValidation() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/v5/orders/users/coupon/${token}/valid`
      );
      return response.data;
    } catch (err) {
      let errorMessage = "Something went wrong.";
      if (isRateLimited(err)) {
        errorMessage = RATE_LIMIT_MESSAGE;
      } else if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      }
      toast.warning(errorMessage, {
        position: "bottom-center",
      });
      return false;
    } finally {
      setLoading(false);
    }
  }

  async function handleNavigation() {
    if (token === "null" || token === undefined || token === null) {
      navigate("/");
      return;
    }

    const data = await checkCouponValidation();

    if (data && data.result) {
      if (Boolean(data.result.show_products) === false) {
        try {
          const swagpacks = (await getCouponItems()).filter((pack) =>
            isPackInStock(pack),
          );
          if (!swagpacks.length) {
            throw new Error(ALL_PACKS_OUT_OF_STOCK_MESSAGE);
          }
          setSelectedPack({ selectedPack: swagpacks });
        } catch (error) {
          toast.warning(error.message, {
            position: "bottom-center",
          });
        }
      } else {
        navigate({
          pathname: "/redemption/checkout",
          search: `?${createSearchParams(params)}`,
        });
      }
    }
  }

  async function getCouponItems() {
    try {
      const res = await fetchCouponItems(token);
      if (
        res.data.success &&
        res.data.result &&
        res.data.result.swagpacks &&
        res.data.result.swagpacks.length > 0
      ) {
        return res.data.result.swagpacks;
      }
      throw new Error("Failed to fetch swagpacks.");
    } catch (err) {
      if (err.message === "Failed to fetch swagpacks.") {
        throw err;
      }
      let errorMessage = "Something went wrong.";
      if (isRateLimited(err)) {
        errorMessage = RATE_LIMIT_MESSAGE;
      } else if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      }
      throw new Error(errorMessage);
    }
  }

  if (loading) {
    return <div className="loading-indicator-admin"></div>;
  }

  return (
    <div
      className="landing-page"
      style={{
        backgroundColor: templateData.backgroundColor || "#1E1665",
      }}
    >
      <div className="landing-page-header">
        <GradientHeader
          logoSrc={templateData.logoImageUrl}
          justifyContent="flex-start"
          headerColor={templateData.headerColor}
        />
      </div>
      <div className="landing-page-body">
        <LayoutComponent
          layout={templateData.layout}
          templateData={templateData}
          onButtonClick={handleNavigation}
          secondaryImage={secondaryImage}
        />
      </div>
      {templateData.customerId !== 383 && (
        <div className="landing-page-footer">
          <a href="https://swageazy.com/" target="_blank" rel="noreferrer">
            © 2026, Powered by Swageazy
          </a>
        </div>
      )}
    </div>
  );
};
